import {
    LIST_ACTS,
    LIST_ACTS_SUCCESS,
    LIST_ACTS_ERROR,
    ADD_ACTS,
    SAVE_ACTS,
    SAVE_ACTS_SUCCESS,
    SAVE_ACTS_ERROR,
    EDIT_ACTS,
    UPDATE_ACTS,
    UPDATE_ACTS_SUCCESS,
    UPDATE_ACTS_ERROR,
    DELETE_ACTS,
    DELETE_ACTS_SUCCESS,
    DELETE_ACTS_ERROR,
    MIGRATE_ACTS,
    MIGRATE_ACTS_SUCCESS,
    MIGRATE_ACTS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    acts: null,
    error: null,
    loading: false,
    actSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_ACTS:
            return {
                ...state,
                loading: true
            }
        case LIST_ACTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_ACTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                acts: action.payload
            }
        case SAVE_ACTS:
        case DELETE_ACTS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_ACTS:
        case MIGRATE_ACTS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_ACTS_ERROR:
        case UPDATE_ACTS_ERROR:
        case DELETE_ACTS_ERROR:
        case MIGRATE_ACTS_ERROR: 
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_ACTS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                acts: [...state.acts, action.payload]
            }
        case ADD_ACTS:
            return {
                ...state,
                actSelected: null,
                isEdit: false
            }
        case EDIT_ACTS:
            return {
                ...state,
                actSelected: action.payload,
                isEdit: true
            }
        case UPDATE_ACTS_SUCCESS:
        case MIGRATE_ACTS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                acts: state.acts.map(act => 
                    act.id === action.payload.id ? act = action.payload : act
                ),
                actselected: null
            }
        case DELETE_ACTS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                acts: state.acts.filter( act => act.id !== action.payload)
            }
        default:
            return state;
    }
}